<pace-app-header></pace-app-header>
<div class="container-fluid safe-area-bottom">
    <router-outlet></router-outlet>
</div>
